
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Bmwonrentinpune() {



  const cardData =
  {
    keyword: 'BMW On Rent in Pune',
    heading: 'SHREE Tours & Travels: BMW On Rent in Pune',
    headingDescription: 'SHREE Tours & Travels offers BMW on rent in Pune, providing a premium and luxurious travel experience for corporate executives, weddings, VIP transfers and special occasions. Whether you need a high-end car for one-way travel, round trips, airport transfers, or business meetings, our well-maintained BMW ensures a smooth, stylish and comfortable ride. With professional chauffeurs, elegant interiors and competitive pricing, we guarantee a first-class travel experience. Choose SHREE Tours & Travels for the best BMW rental service in Pune.',

    top: 'Top Places to Visit in Pune with SHREE Tours & Travels',
"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historic fortification built in 1732 and served as the seat of the Peshwas of the Maratha Empire. This grand palace is known for its majestic entrance, intricate wooden carvings and sprawling gardens. Despite being largely destroyed by a fire in 1828, its ruins still stand as a reminder of Pune’s glorious past. Visitors can explore the remains of the palace, enjoy the light and sound show in the evening and learn about the legends of the fort, including its famous haunted stories."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892 by Sultan Muhammed Shah Aga Khan III, Aga Khan Palace is a significant historical landmark. It played a crucial role in India's independence movement, as Mahatma Gandhi, Kasturba Gandhi and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with rare photographs, personal belongings of Gandhi and an eternal flame in honor of freedom fighters. The Italian-style architecture and beautifully maintained gardens make it a peaceful and educational visit."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Situated on a hilltop, Sinhagad Fort is an iconic landmark known for its historical significance and breathtaking views. The fort was the site of the famous Battle of Sinhagad in 1670, where Tanaji Malusare, a brave Maratha warrior, fought for Chhatrapati Shivaji Maharaj. It is a popular trekking destination, offering a rewarding climb with stunning views of the Sahyadri mountains. Visitors can enjoy local Maharashtrian delicacies like pithla-bhakri and kanda bhaji at small eateries near the fort."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An ancient rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple dates back to the 8th century. The temple is carved from a single basalt rock and features massive pillars, intricate sculptures and a Nandi (bull) statue. Its unique architecture and serene ambiance make it a fascinating place for history and spirituality enthusiasts. The temple offers a peaceful escape from the bustling city and is an ideal spot for meditation."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "The Raja Dinkar Kelkar Museum is a treasure trove of India’s cultural heritage, featuring over 20,000 artifacts collected by Dr. Dinkar Kelkar. The museum showcases a diverse collection of ancient musical instruments, traditional weapons, sculptures, paintings and beautifully carved doors. One of its highlights is the ‘Mastani Mahal,’ a reconstructed palace of Bajirao Peshwa’s beloved queen. This museum provides a captivating insight into India’s artistic and historical richness."
    },
    {
        "title": "Pashan Lake",
        "description": "Pashan Lake is an artificial lake that attracts nature lovers and birdwatchers. It is home to various migratory birds, making it a paradise for photographers and wildlife enthusiasts. The lake has a well-maintained walking track, making it a great spot for morning and evening strolls. The tranquil surroundings and fresh air offer a refreshing break from the city's hustle and bustle."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is one of the world’s most famous spiritual centers. It offers various meditation programs, yoga sessions and wellness therapies, attracting visitors from across the globe. The ashram promotes a unique blend of Eastern and Western spiritual practices. Visitors can also explore the beautifully landscaped Osho Teerth Park nearby, making it a great place for relaxation and self-discovery."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered temples, attracting thousands of devotees. The temple is dedicated to Lord Ganesha and features a magnificent idol adorned with gold and jewels. During the Ganesh Chaturthi festival, the temple becomes a major attraction with grand celebrations and processions. The temple’s divine ambiance and spiritual significance make it a must-visit for religious and cultural travelers."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Spread across 130 acres, the Rajiv Gandhi Zoological Park consists of a zoo, a snake park and a wildlife rescue center. It houses a variety of animals, including tigers, leopards, crocodiles and elephants. The snake park is one of its major attractions, featuring different species of snakes and reptiles. The well-maintained environment and educational exhibits make it an excellent place for family outings and nature lovers."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam is a popular weekend getaway located on the Mutha River. It serves as the primary water source for Pune and is surrounded by picturesque hills and lush greenery. Visitors can enjoy breathtaking sunset views, take leisurely walks along the dam, or relish street food like vada pav and roasted corn from local vendors. The nearby Sinhagad Fort and Panshet Dam add to its appeal, making it a perfect one-day picnic spot."
    }
],  
    
            
"services": [
    {
      "name": "BMW Car Rental Pune",
      "description": "Rent a BMW in Pune for a stylish and luxurious ride. Known for its exceptional performance and premium features, the BMW ensures a smooth and comfortable journey, whether for city travel or outstation trips."
    },
    {
      "name": "Rent BMW in Pune",
      "description": "Book a BMW in Pune for any travel need. Whether it’s a business trip, family vacation, or group outing, enjoy a smooth and luxurious ride with top-of-the-line features."
    },
    {
      "name": "Luxury BMW Hire Pune",
      "description": "Experience the pinnacle of luxury with a BMW hire in Pune. With its sophisticated design and superior driving performance, this vehicle is perfect for both leisure and business trips."
    },
    {
      "name": "BMW for Outstation Pune",
      "description": "Travel to outstation destinations in style with a BMW rental from Pune. This car offers unmatched comfort, space and performance for long-distance travel."
    },
    {
      "name": "BMW Car Hire for Corporate Travel Pune",
      "description": "For corporate trips, hire a BMW in Pune. The vehicle’s executive feel, combined with luxury and comfort, makes it ideal for meetings, conferences and client travel."
    },
    {
      "name": "Book BMW for Family Travel Pune",
      "description": "Make your family trips more memorable by renting a BMW in Pune. With ample space, luxurious seating and smooth performance, it’s perfect for long-distance travel or family vacations."
    },
    {
      "name": "BMW Hire for Group Travel Pune",
      "description": "Travel with friends or colleagues in style by hiring a BMW for group travel in Pune. Its spacious interiors and premium features make it an excellent choice for group outings or tours."
    },
    {
      "name": "Affordable BMW Rental Pune",
      "description": "Looking for an affordable yet luxurious ride? Rent a BMW in Pune at competitive prices and experience comfort, style and performance without the premium price tag."
    },
    {
      "name": "BMW for Airport Pickup Pune",
      "description": "Book a BMW for a seamless and luxurious airport pickup in Pune. Enjoy a smooth ride with a professional driver, ensuring a comfortable and timely transfer to and from the airport."
    },
    {
      "name": "BMW for Business Trip Pune",
      "description": "Rent a BMW for your business trip in Pune. With its luxurious interiors and smooth ride, it’s perfect for professionals traveling for meetings, conferences, or client visits."
    },
    {
      "name": "BMW Hire for Weekend Travel Pune",
      "description": "Hire a BMW for a weekend getaway from Pune. Whether you're exploring nearby destinations or enjoying a luxury ride, the BMW is the ideal vehicle for your weekend plans."
    },
    {
      "name": "BMW for Special Occasions Pune",
      "description": "Make your special occasions unforgettable by renting a BMW in Pune. Whether it's a wedding, anniversary, or any significant event, this luxury vehicle adds an extra touch of elegance."
    },
    {
      "name": "Luxury BMW for Events in Pune",
      "description": "Rent a luxury BMW for your events in Pune. Perfect for weddings, parties, or any celebration, this vehicle provides unmatched luxury and style for your special day."
    },
    {
      "name": "BMW Car Hire for Luxury Travel Pune",
      "description": "For those seeking the ultimate in luxury travel, rent a BMW in Pune. With its elegant interiors and high-performance features, it ensures a truly luxurious experience for your journey."
    }
  ],
  "tableData": [
    ["- BMW Car Rental Pune", "- Rent BMW in Pune"],
    ["- Luxury BMW Hire Pune", "- BMW for Outstation Pune"],
    ["- BMW Car Hire for Corporate Travel Pune", "- Book BMW for Family Travel Pune"],
    ["- BMW Hire for Group Travel Pune", "- Affordable BMW Rental Pune"],
    ["- BMW for Airport Pickup Pune", "- BMW for Business Trip Pune"],
    ["- BMW Hire for Weekend Travel Pune", "- BMW for Special Occasions Pune"],
    ["- Luxury BMW for Events in Pune", "- BMW Car Hire for Luxury Travel Pune"]
  ],

  whychoose: [
    {
      "WhyChooseheading": "Unmatched Luxury and Performance",
      "WhyChoosedescription": "The BMW is a symbol of luxury, performance and cutting-edge technology. Renting a BMW in Pune offers an unparalleled driving experience, combining exceptional comfort with dynamic performance. Whether for business or leisure, the BMW ensures you travel in style and sophistication."
    },
    {
      "WhyChooseheading": "Ideal for Business and Special Occasions",
      "WhyChoosedescription": "A BMW is perfect for business travel, corporate events, or special occasions such as weddings and VIP functions. With its sleek design, luxurious interior and high-performance engine, a BMW elevates any occasion, offering you both elegance and comfort throughout the journey."
    },
    {
      "WhyChooseheading": "Well-Maintained and Safe Vehicles",
      "WhyChoosedescription": "All our BMW vehicles are meticulously maintained and regularly serviced for peak performance and safety. Each car undergoes comprehensive inspections to ensure cleanliness, safety and mechanical reliability, providing you peace of mind as you travel in a safe, top-quality vehicle."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly trained and experienced, ensuring a smooth, safe and comfortable ride. They are familiar with the best routes in Pune, prioritizing punctuality, safety and your overall experience, making your journey both enjoyable and stress-free."
    },
    {
      "WhyChooseheading": "Perfect for Luxury Travel",
      "WhyChoosedescription": "Whether you're attending a business event, a wedding, or a special celebration, renting a BMW is the perfect way to make a statement. With its luxurious interior, advanced features and impressive performance, BMW offers a seamless balance of comfort, elegance and style for any occasion."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking a BMW with SHREE Tours & Travels is quick and easy. You can make your reservation online through our simple platform, or reach out to our customer service team for personalized assistance, ensuring a hassle-free and efficient booking experience."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for BMW rentals in Pune. Whether it's a last-minute booking or a planned trip, we are ready to accommodate your travel needs anytime, ensuring you have access to a luxurious, reliable vehicle whenever you need it."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we prioritize customer satisfaction. We are dedicated to providing exceptional service, ensuring that every BMW rental meets the highest standards of luxury, safety and reliability. Our goal is to make your experience seamless and enjoyable from start to finish."
    }
  ]
  
  
  

  
  
  
  
  

  
  



        
  }
  const faqData = [
    {
        question: "How can I rent a BMW in Pune?",
        answer: "You can easily rent a BMW in Pune through our website or by contacting our customer service for assistance."
    },
    {
        question: "What is the rental rate for a BMW in Pune?",
        answer: "The rental rate for a BMW varies depending on the duration and type of trip. Please contact us for detailed pricing information."
    },
    {
        question: "Is the rental rate for the BMW inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. We provide detailed pricing information during the booking process."
    },
    {
        question: "Can I rent a BMW for a one-way trip in Pune?",
        answer: "Yes, we offer one-way rental options for the BMW for trips within Pune or to nearby cities."
    },
    {
        question: "Do you provide drivers with the BMW rental in Pune?",
        answer: "Yes, all our BMW rentals come with experienced drivers who are familiar with the local routes to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for BMW bookings in Pune?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for renting a BMW in Pune?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the BMW vehicles insured for safety during trips in Pune?",
        answer: "Yes, all our BMW vehicles are fully insured for your safety and peace of mind during the journey."
    },
    {
        question: "Can I request a child seat for my BMW rental in Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for renting a BMW in Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'I rented a BMW from SHREE Tours & Travels for a luxury trip in Pune. The car was exquisite and the driver ensured a smooth, comfortable ride.',
        name: 'Mr. Harsh Mehta',
    },
    {
        text: 'SHREE Tours & Travels made our journey in Pune unforgettable with their BMW rental service. The car was pristine and the driver was very polite and professional.',
        name: 'Miss. Priya Shah',
    }
];


















  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "BMW On Rent in Pune",
  "description": "Rent a luxury BMW in Pune with S9 Travels for a premium travel experience. Whether you need a BMW for outstation trips, business travel, family vacations, or special occasions, we offer affordable BMW rentals. Book a BMW for airport pickups, corporate travel, group trips, or weekend getaways, and enjoy comfort, elegance, and style throughout your journey.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "1354"
  }
};




  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>BMW on Rent in Pune | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Rent a BMW for luxury travel in Pune. Whether for family trips, corporate travel, outstation journeys, or special occasions, our BMW rental service offers unmatched comfort and style. Book your BMW today for a premium experience!" />
  <meta name="keywords" content="BMW Rental Pune, Rent BMW in Pune, BMW Car Hire Pune, Luxury BMW Rental Pune, BMW for Outstation in Pune, BMW Hire for Business Travel Pune, Rent BMW for Group Travel Pune, BMW for Airport Pickup Pune, Book BMW for Family Trip Pune, BMW Hire for Corporate Travel Pune, BMW Car Rental for Luxury Trip Pune, BMW for Special Occasions in Pune, Luxury BMW for Events in Pune, BMW Hire for Weekend Travel Pune" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/32.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Bmwonrentinpune;